import { render, staticRenderFns } from "./TopNav.vue?vue&type=template&id=63a1d6ba&scoped=true&"
import script from "./TopNav.vue?vue&type=script&lang=js&"
export * from "./TopNav.vue?vue&type=script&lang=js&"
import style0 from "./TopNav.vue?vue&type=style&index=0&id=63a1d6ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63a1d6ba",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/source/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('63a1d6ba')) {
      api.createRecord('63a1d6ba', component.options)
    } else {
      api.reload('63a1d6ba', component.options)
    }
    module.hot.accept("./TopNav.vue?vue&type=template&id=63a1d6ba&scoped=true&", function () {
      api.rerender('63a1d6ba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/global/TopNav.vue"
export default component.exports